<template>
  <div class="pc-status-bar">
    <div class="pc-status-bar-container">
      <router-link to="/profile" class="pc-status-bar__logo">
        <img src="@/assets/img/logo.svg" alt="logo" />
      </router-link>
      <div v-if="showContent" class="pc-status-bar-content">
        <icu-icon
          v-if="showBackButton"
          class="pc-status-bar__back-btn"
          icon-name="arrow-down"
          @click="$emit('back')"
        />
        <div class="pc-status-bar__title">
          <div v-if="$route.meta.title" class="pc-status-bar__title-wrap">
            {{ $t($route.meta.title) }}
            <template v-if="$route.name === 'profile'">
              <span v-if="userInfo.backoffice_status === 'active'" class="activity">{{ $t('pc.general.active') }}</span>
              <span v-else class="activity processing">{{ $t('pc.general.in-process') }}</span>
            </template>
          </div>
        </div>
      </div>
      <user-block />
      <pc-language-switcher :class="{show: userInfo.profile_status !== 'FULL'}" />
      <div v-if="userInfo.profile_status === 'FULL'" class="pc-menu-actions">
        <icu-icon
          v-show="!showClose"
          class="menu-btn pc-menu-icon"
          @click.native.stop="openMenu"
        />
        <icu-icon v-show="showClose" class="pc-menu-close" />
      </div>
      <div class="pc-status-bar__status-ribbon" :style="{width: `${width}%`}" />
    </div>
  </div>
</template>

<script>
import IcuIcon from '@/components/common/IcuIcon.vue'
import UserBlock from '@/assets/scss/components/views/RegisterPage/UserBlock'
import PcLanguageSwitcher from '@/components/common/PcLanguageSwitcher'
import {mapGetters} from 'vuex'


export default {
  name: 'PcStatusBar',
  components: {PcLanguageSwitcher, UserBlock, IcuIcon },
  props: {
    width: {
      type: Number,
      default: 0
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    showContent: {
      type: Boolean,
      default: true,
    },
    showClose: Boolean,
  },
  computed:{
    ...mapGetters(['userInfo'])
  },
  methods: {
    openMenu() {
      this.$emit('open-menu')
    }
  }
}
</script>
